function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDrcLogoEscuroInterno = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "111.8898 237.3718 149.8972 50.0002",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath0",
    transform: ""
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 1500 L 3000 1500 L 3000 0 L 0 0 Z",
    style: {
      fill: "none",
      clipRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    className: "page-1",
    transform: "matrix(0.05492400750517846, 0, 0, -0.05492400750517846, 102.66362762451172, 295.46844482421886)",
    style: {}
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {}
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 167.981 1057.764 L 2897.155 1057.764 L 2897.155 147.412 L 167.981 147.412 L 167.981 1057.764 Z",
    style: {
      fill: "rgb(7, 20, 55)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {},
    transform: "matrix(1, 0, 0, 1, -90, -177)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 2669.968018, 1044.780396)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 0 L 0.001 0 L 0.001 0 L 155.231 0 L 155.231 120.058 L 0.001 120.058 C -278.858 120.057 -504.919 -84.328 -504.919 -336.45 L -504.919 -336.452 L -372.125 -336.452 C -372.124 -150.933 -205.188 0 0 0",
    style: {
      fill: "rgb(255, 96, 30)",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 2669.96875, 1003.505371)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 0 L 0 -0.001 L -0.001 -0.001 C -180.018 -0.001 -326.471 -132.42 -326.473 -295.177 L -193.662 -295.177 L -193.662 -295.175 C -193.662 -198.474 -106.957 -120.081 0 -120.081 L 155.23 -120.081 L 155.23 -0.001 L 0 -0.001 Z",
    style: {
      fill: "rgb(255, 96, 30)",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 2179.84082, 935.136475)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 0 C -56.595 42.61 -129.219 68.368 -208.453 68.368 L -208.454 68.368 L -208.454 68.369 L -208.454 68.369 L -363.684 68.369 L -363.684 -51.712 L -208.454 -51.712 C -142.571 -51.712 -84.547 -81.56 -49.591 -127.02 C -39.46 -82.186 -22.515 -39.596 0 0",
    style: {
      fill: "rgb(255, 96, 30)",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 2286.217285, 1065.069092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 0 C -86.333 62.382 -195.719 99.769 -314.831 99.769 L -470.06 99.769 L -470.06 -20.288 L -314.831 -20.288 L -314.83 -20.289 L -314.829 -20.289 C -227.449 -20.289 -147.076 -47.737 -83.511 -93.496 C -59.875 -59.336 -31.799 -27.963 0 0",
    style: {
      fill: "rgb(255, 96, 30)",
      fillOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url('#clippath0')"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url('#clippath0')"
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(333.1952 287.5496)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 0 C -42.814 0 -77.959 13.458 -105.431 40.363 C -132.914 67.279 -146.647 100.312 -146.647 139.496 C -146.647 178.919 -132.946 212.02 -105.531 238.811 C -78.122 265.603 -42.945 278.993 0 278.993 C 38.51 278.993 70.523 268.786 96.04 248.372 C 121.556 227.948 135.427 201.337 137.651 168.531 L 80.672 168.531 C 78.58 183.756 70.786 197.293 57.273 209.154 C 43.766 221.015 24.671 226.951 0 226.951 C -27.54 226.951 -49.304 218.658 -65.298 202.074 C -81.286 185.5 -89.28 164.634 -89.28 139.496 C -89.28 114.121 -81.286 93.152 -65.298 76.568 C -49.304 59.983 -27.54 51.691 0 51.691 C 23.499 51.691 42.294 57.627 56.39 69.488 C 70.492 81.348 78.58 94.421 80.672 108.695 L 137.651 108.695 C 135.032 79.66 120.322 54.285 93.496 32.58 C 66.67 10.864 35.509 0 0 0",
    style: {
      fill: "rgb(236, 236, 237)",
      fillOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url('#clippath0')"
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(588.3298 329.5095)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 0 C 14.747 0 29.689 5.902 44.837 17.706 L 44.837 48.678 L 14.879 44.962 C -12.667 41.541 -26.431 33.69 -26.431 21.422 C -26.431 14.931 -23.957 9.731 -18.995 5.845 C -14.033 1.948 -7.706 0 0 0 M -16.84 -41.246 C -38.51 -41.246 -55.901 -36.058 -69.019 -25.67 C -82.138 -15.282 -88.697 -0.714 -88.697 18.057 C -88.697 35.763 -80.052 50.094 -62.755 61.071 C -45.458 72.048 -24.019 78.652 1.566 80.895 L 44.837 84.441 L 44.837 87.805 C 44.837 98.896 42.024 106.86 36.417 111.697 C 30.804 116.534 22.384 118.958 11.158 118.958 C -15.079 118.958 -29.244 108.808 -31.33 88.508 L -82.627 88.508 C -81.06 109.986 -72.578 127.692 -57.173 141.615 C -41.774 155.537 -18.406 162.504 12.918 162.504 C 40.984 162.504 62.949 156.341 78.805 144.005 C 94.668 131.68 102.593 112.818 102.593 87.454 L 102.593 27.618 C 102.593 11.679 108.469 3.716 120.216 3.716 L 120.216 -38.414 C 118.912 -38.414 116.463 -38.471 112.873 -38.595 C 109.283 -38.709 106.445 -38.765 104.359 -38.765 L 98.878 -38.765 L 92.613 -38.765 C 91.823 -38.765 89.969 -38.709 87.031 -38.595 C 84.093 -38.471 82.1 -38.301 81.06 -38.063 C 80.014 -37.825 78.154 -37.474 75.479 -36.998 C 72.803 -36.522 70.843 -35.967 69.602 -35.322 C 68.362 -34.665 66.664 -33.815 64.515 -32.75 C 62.36 -31.685 60.625 -30.507 59.322 -29.204 C 58.018 -27.913 56.615 -26.406 55.112 -24.696 C 53.614 -22.985 52.343 -21.003 51.296 -18.76 C 45.157 -25.489 35.891 -30.926 23.493 -35.05 C 11.089 -39.184 -2.349 -41.246 -16.84 -41.246",
    style: {
      fill: "rgb(236, 236, 237)",
      fillOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url('#clippath0')"
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(999.7028 492.7273)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 0 C 24.539 0 43.497 -6.231 56.878 -18.68 C 70.26 -31.13 76.951 -48.859 76.951 -71.878 L 76.951 -201.632 L 13.119 -201.632 L 13.119 -79.128 C 13.119 -59.779 2.544 -50.105 -18.6 -50.105 C -30.61 -50.105 -41.016 -53.107 -49.83 -59.134 C -58.639 -65.149 -63.043 -73.113 -63.043 -83.025 L -63.043 -201.632 L -127.27 -201.632 L -127.27 -79.128 C -127.27 -59.779 -137.644 -50.105 -158.4 -50.105 C -170.409 -50.105 -180.915 -53.107 -189.924 -59.134 C -198.927 -65.149 -203.431 -73.113 -203.431 -83.025 L -203.431 -201.632 L -267.063 -201.632 L -267.063 -2.3 L -210.285 -2.3 L -206.958 -25.137 C -199.516 -17.355 -189.761 -11.215 -177.683 -6.729 C -165.61 -2.243 -153.181 0 -140.388 0 C -112.848 0 -91.629 -10.275 -76.75 -30.802 C -68.136 -21.365 -56.947 -13.877 -43.171 -8.326 C -29.401 -2.775 -15.01 0 0 0",
    style: {
      fill: "rgb(236, 236, 237)",
      fillOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1107.796 490.428 L 1170.25 490.428 L 1170.25 291.096 L 1107.796 291.096 Z",
    style: {
      fill: "rgb(236, 236, 237)",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1339.4249 493.0785)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 0 C 25.711 0 45.721 -6.344 60.011 -19.031 C 74.307 -31.719 81.449 -49.686 81.449 -72.931 L 81.449 -201.983 L 17.623 -201.983 L 17.623 -79.842 C 17.623 -60.006 5.482 -50.094 -18.794 -50.094 C -31.85 -50.094 -43.271 -53.107 -53.063 -59.122 C -62.849 -65.149 -67.748 -73.113 -67.748 -83.025 L -67.748 -201.983 L -131.574 -201.983 L -131.574 -2.651 L -74.207 -2.651 L -70.485 -26.905 C -62.529 -18.646 -52.117 -12.099 -39.255 -7.261 C -26.4 -2.424 -13.313 0 0 0",
    style: {
      fill: "rgb(236, 236, 237)",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1583.5898 492.0136)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 0 C 25.717 0 45.689 -6.287 59.917 -18.85 C 74.144 -31.413 81.255 -49.323 81.255 -72.58 L 81.255 -200.918 L 17.623 -200.918 L 17.623 -79.83 C 17.623 -60.006 5.419 -50.094 -18.989 -50.094 C -32.044 -50.094 -43.465 -53.107 -53.257 -59.122 C -63.043 -65.138 -67.942 -73.113 -67.942 -83.025 L -67.942 -200.918 L -131.574 -200.918 L -131.574 70.994 L -67.942 70.994 L -67.942 -24.073 C -59.716 -16.641 -49.467 -10.773 -37.2 -6.457 C -24.934 -2.152 -12.53 0 0 0",
    style: {
      fill: "rgb(236, 236, 237)",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1794.2756 338.8893)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 0 C 15.01 0 27.315 5.018 36.912 15.044 C 46.504 25.081 51.303 37.474 51.303 52.223 C 51.303 66.973 46.504 79.423 36.912 89.573 C 27.315 99.723 15.01 104.798 0 104.798 C -15.267 104.798 -27.64 99.779 -37.1 89.754 C -46.566 79.717 -51.296 67.211 -51.296 52.223 C -51.296 37.236 -46.566 24.786 -37.1 14.874 C -27.64 4.962 -15.267 0 0 0 M 81.649 -20.799 C 60.111 -40.442 32.897 -50.275 0 -50.275 C -32.89 -50.275 -60.105 -40.442 -81.643 -20.799 C -103.182 -1.144 -113.951 23.189 -113.951 52.223 C -113.951 81.258 -103.182 105.625 -81.643 125.336 C -60.105 145.047 -32.89 154.903 0 154.903 C 32.897 154.903 60.111 145.047 81.649 125.336 C 103.188 105.625 113.957 81.258 113.957 52.223 C 113.957 23.189 103.188 -1.144 81.649 -20.799",
    style: {
      fill: "rgb(236, 236, 237)",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2061.1506 493.0785)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 0 C 25.711 0 45.721 -6.344 60.011 -19.031 C 74.307 -31.719 81.449 -49.686 81.449 -72.931 L 81.449 -201.983 L 17.623 -201.983 L 17.623 -79.842 C 17.623 -60.006 5.482 -50.094 -18.794 -50.094 C -31.85 -50.094 -43.271 -53.107 -53.063 -59.122 C -62.849 -65.149 -67.748 -73.113 -67.748 -83.025 L -67.748 -201.983 L -131.574 -201.983 L -131.574 -2.651 L -74.207 -2.651 L -70.485 -26.905 C -62.529 -18.646 -52.117 -12.099 -39.255 -7.261 C -26.4 -2.424 -13.313 0 0 0",
    style: {
      fill: "rgb(236, 236, 237)",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2266.7432 448.8189)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 0 C -24.539 0 -39.681 -11.974 -45.42 -35.933 L 42.482 -35.933 C 38.184 -11.974 24.013 0 0 0 M 102.987 -57.706 C 102.987 -63.019 102.599 -68.683 101.81 -74.699 L -46.598 -74.699 C -44.769 -87.794 -39.481 -98.035 -30.735 -105.41 C -21.996 -112.796 -11.095 -116.477 1.961 -116.477 C 24.928 -116.477 40.853 -108.683 49.736 -93.107 L 100.243 -93.107 C 96.459 -112.467 85.959 -128.372 68.719 -140.822 C 51.49 -153.272 28.712 -159.491 0.395 -159.491 C -31.719 -159.491 -57.793 -150.02 -77.828 -131.079 C -97.863 -112.139 -107.88 -87.794 -107.88 -58.057 C -107.88 -28.083 -98.32 -3.659 -79.2 15.225 C -60.073 34.109 -33.417 43.546 0.783 43.546 C 32.37 43.546 57.304 34.461 75.573 16.29 C 93.853 -1.88 102.987 -26.553 102.987 -57.706",
    style: {
      fill: "rgb(236, 236, 237)",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 2393.825 490.428 L 2456.285 490.428 L 2456.285 291.096 L 2393.825 291.096 Z",
    style: {
      fill: "rgb(236, 236, 237)",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2638.3782 492.7273)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 0 L 0 -50.456 C -28.066 -50.456 -48.79 -55.237 -62.159 -64.798 C -75.541 -74.347 -82.232 -91.227 -82.232 -115.424 L -82.232 -201.632 L -146.058 -201.632 L -146.058 -2.3 L -86.342 -2.3 L -82.62 -29.386 C -78.586 -21.603 -69.477 -14.761 -55.306 -8.859 C -41.147 -2.957 -22.716 0 0 0",
    style: {
      fill: "rgb(236, 236, 237)",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2759.001 338.8893)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 0 C 15.01 0 27.315 5.018 36.912 15.044 C 46.498 25.081 51.296 37.474 51.296 52.223 C 51.296 66.973 46.498 79.423 36.912 89.573 C 27.315 99.723 15.01 104.798 0 104.798 C -15.273 104.798 -27.64 99.779 -37.1 89.754 C -46.573 79.717 -51.296 67.211 -51.296 52.223 C -51.296 37.236 -46.573 24.786 -37.1 14.874 C -27.64 4.962 -15.273 0 0 0 M 81.643 -20.799 C 60.105 -40.442 32.89 -50.275 0 -50.275 C -32.89 -50.275 -60.104 -40.442 -81.643 -20.799 C -103.181 -1.144 -113.957 23.189 -113.957 52.223 C -113.957 81.258 -103.181 105.625 -81.643 125.336 C -60.104 145.047 -32.89 154.903 0 154.903 C 32.89 154.903 60.105 145.047 81.643 125.336 C 103.182 105.625 113.957 81.258 113.957 52.223 C 113.957 23.189 103.182 -1.144 81.643 -20.799",
    style: {
      fill: "rgb(236, 236, 237)",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(334.799 663.3495)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 0 C 27.283 0 49.21 7.205 65.793 21.603 C 82.364 36.001 90.658 58.182 90.658 88.157 C 90.658 118.845 82.432 141.264 65.987 155.424 C 49.536 169.596 27.54 176.676 0 176.676 L -43.659 176.676 L -43.659 0 Z M -103.77 224.119 L 0.395 224.119 C 43.728 224.119 79.626 212.133 108.081 188.174 C 136.535 164.215 150.763 130.876 150.763 88.157 C 150.763 45.087 136.598 11.657 108.275 -12.121 C 79.952 -35.911 43.992 -47.794 0.395 -47.794 L -103.77 -47.794 Z",
    style: {
      fill: "rgb(236, 236, 237)",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(625.9501 663.3495)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 0 C 15.01 0 27.315 5.018 36.912 15.044 C 46.504 25.081 51.303 37.474 51.303 52.223 C 51.303 66.973 46.504 79.423 36.912 89.573 C 27.315 99.723 15.01 104.798 0 104.798 C -15.267 104.798 -27.64 99.779 -37.1 89.754 C -46.566 79.717 -51.296 67.211 -51.296 52.223 C -51.296 37.236 -46.566 24.786 -37.1 14.874 C -27.64 4.962 -15.267 0 0 0 M 81.649 -20.799 C 60.111 -40.442 32.897 -50.275 0 -50.275 C -32.89 -50.275 -60.105 -40.442 -81.643 -20.799 C -103.182 -1.144 -113.951 23.189 -113.951 52.223 C -113.951 81.258 -103.182 105.625 -81.643 125.336 C -60.105 145.047 -32.89 154.903 0 154.903 C 32.897 154.903 60.111 145.047 81.649 125.336 C 103.188 105.625 113.957 81.258 113.957 52.223 C 113.957 23.189 103.188 -1.144 81.649 -20.799",
    style: {
      fill: "rgb(236, 236, 237)",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(986.6093 814.8878)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 0 L 0 -199.332 L -56.778 -199.332 L -60.499 -174.376 C -68.462 -182.872 -78.805 -189.454 -91.535 -194.11 C -104.259 -198.777 -117.284 -201.1 -130.596 -201.1 C -154.872 -201.1 -174.651 -193.929 -189.924 -179.598 C -205.192 -165.257 -212.828 -146.814 -212.828 -124.271 L -212.828 0 L -149.197 0 L -149.197 -117.372 C -149.197 -127.522 -145.901 -135.633 -139.311 -141.717 C -132.72 -147.789 -123.68 -150.825 -112.19 -150.825 C -99.398 -150.825 -88.046 -147.675 -78.122 -141.354 C -68.205 -135.044 -63.243 -127.047 -63.243 -117.372 L -63.243 0 Z",
    style: {
      fill: "rgb(236, 236, 237)",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1144.6143 615.2043)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 0 C -11.753 0 -21.313 0.238 -28.687 0.702 C -36.06 1.178 -44.154 2.685 -52.963 5.222 C -61.777 7.76 -68.662 11.385 -73.624 16.109 C -78.586 20.821 -82.796 27.528 -86.248 36.194 C -89.712 44.871 -91.441 55.52 -91.441 68.151 L -91.441 155.073 L -128.836 155.073 L -128.836 200.386 L -91.441 200.386 L -91.441 272.264 L -32.897 272.264 L -32.897 200.386 L 26.82 200.386 L 26.82 155.073 L -32.897 155.073 L -32.897 71.697 C -32.897 61.535 -30.09 54.614 -24.477 50.887 C -18.863 47.171 -10.707 45.313 0 45.313 L 27.603 45.313 L 27.603 0 Z",
    style: {
      fill: "rgb(236, 236, 237)",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1310.0618 663.3495)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 0 C 15.01 0 27.315 5.018 36.912 15.044 C 46.504 25.081 51.303 37.474 51.303 52.223 C 51.303 66.973 46.504 79.423 36.912 89.573 C 27.315 99.723 15.01 104.798 0 104.798 C -15.267 104.798 -27.64 99.779 -37.1 89.754 C -46.566 79.717 -51.296 67.211 -51.296 52.223 C -51.296 37.236 -46.566 24.786 -37.1 14.874 C -27.64 4.962 -15.267 0 0 0 M 81.649 -20.799 C 60.111 -40.442 32.896 -50.275 0 -50.275 C -32.89 -50.275 -60.105 -40.442 -81.643 -20.799 C -103.182 -1.144 -113.951 23.189 -113.951 52.223 C -113.951 81.258 -103.182 105.625 -81.643 125.336 C -60.105 145.047 -32.89 154.903 0 154.903 C 32.896 154.903 60.111 145.047 81.649 125.336 C 103.188 105.625 113.957 81.258 113.957 52.223 C 113.957 23.189 103.188 -1.144 81.649 -20.799",
    style: {
      fill: "rgb(236, 236, 237)",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1597.8862 817.1874)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 0 L 0 -50.456 C -28.066 -50.456 -48.79 -55.237 -62.166 -64.798 C -75.547 -74.347 -82.238 -91.227 -82.238 -115.424 L -82.238 -201.632 L -146.064 -201.632 L -146.064 -2.3 L -86.348 -2.3 L -82.627 -29.386 C -78.586 -21.603 -69.477 -14.761 -55.312 -8.859 C -41.154 -2.957 -22.716 0 0 0",
    style: {
      fill: "rgb(236, 236, 237)",
      fillOpacity: 1
    }
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDrcLogoEscuroInterno);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/drc_logo_escuro_interno.77cd40e4aeba10cdd5d06cb87273f639.svg";